import { MtUser } from "server/models"

export interface UserProfileState {
    profileView: MtUser
    profileEdit: MtUser

    reloadView: boolean
    reloadEdit: boolean
}

export const USER_PROFILE_VIEW = "USER_PROFILE_VIEW"
export const USER_PROFILE_EDIT = "USER_PROFILE_EDIT"

export const USER_PROFILE_RELOAD_VIEW = "USER_PROFILE_RELOAD_VIEW"
export const USER_PROFILE_RELOAD_EDIT = "USER_PROFILE_RELOAD_EDIT"
